/**
 * Service Type Utilities
 *
 * Formatting and lookup helpers for IATA service type codes.
 * Data is fetched from the API via useGetServiceTypesQuery().
 */

import type { ServiceType } from '../../services/redux/api/serviceType.api';
export type { ServiceType };

/**
 * Format service type for display
 * Strips category prefix (e.g. "Scheduled Passenger - Normal Services" → "Normal Services")
 * Example: "J — Normal Services"
 */
export function formatServiceTypeLabel(serviceType: ServiceType): string {
  const desc = serviceType.description.includes(' - ')
    ? serviceType.description.split(' - ').slice(1).join(' - ')
    : serviceType.description;
  return `${serviceType.code} — ${desc}`;
}

/**
 * Find service type by code
 */
export function findServiceTypeByCode(serviceTypes: ServiceType[], code: string): ServiceType | undefined {
  return serviceTypes.find(st => st.code === code);
}
